import { useInstitutionStore } from '~/entities/institution/@x/order';

/**
 * Получает название добавки по ID из store institution
 * @param addonId - ID добавки (может быть string или number)
 * @returns Название добавки или fallback текст
 */
export function getAddonName(addonId: string | number): string {
  const institutionStore = useInstitutionStore();
  const addons = institutionStore.addons;
  
  // Приводим ID к числу для сравнения
  const numericId = typeof addonId === 'string' ? Number(addonId) : addonId;
  
  // Ищем добавку в store
  const addon = addons.find(a => a.id === numericId);
  
  if (addon) {
    return addon.name;
  }
  
  // Fallback: если не найдено, возвращаем ID
  return `Дополнение #${addonId}`;
}

/**
 * Получает цену добавки по ID из store institution
 * @param addonId - ID добавки (может быть string или number)
 * @returns Цена добавки или 0
 */
export function getAddonPrice(addonId: string | number): number {
  const institutionStore = useInstitutionStore();
  const addons = institutionStore.addons;
  
  // Приводим ID к числу для сравнения
  const numericId = typeof addonId === 'string' ? Number(addonId) : addonId;
  
  // Ищем добавку в store
  const addon = addons.find(a => a.id === numericId);
  
  return addon?.price || 0;
}

/**
 * Получает название исключаемого ингредиента по ID из store institution
 * @param excludeId - ID исключаемого ингредиента (может быть string или number)
 * @returns Название ингредиента или fallback текст
 */
export function getExcludeName(excludeId: string | number): string {
  const institutionStore = useInstitutionStore();
  const excludeIngredients = institutionStore.excludeIngredients;
  
  // Приводим ID к числу для сравнения
  const numericId = typeof excludeId === 'string' ? Number(excludeId) : excludeId;
  
  // Ищем ингредиент в store
  const exclude = excludeIngredients.find((e: any) => {
    // Проверяем разные возможные структуры
    const id = typeof e === 'object' ? e.id : e;
    return Number(id) === numericId;
  });
  
  if (exclude) {
    // Если это объект с полем name
    if (typeof exclude === 'object' && exclude.name) {
      return exclude.name;
    }
    // Если это строка напрямую
    if (typeof exclude === 'string') {
      return exclude;
    }
  }
  
  // Fallback: если не найдено, возвращаем ID
  return `Исключение #${excludeId}`;
}

/**
 * Преобразует массив ID добавок в массив объектов с названиями и ценами
 * @param addonIds - Массив ID добавок (string[] или number[])
 * @returns Массив объектов { id, name, price }
 */
export function mapAddonIdsToNames(addonIds: (string | number)[]): Array<{ id: string | number; name: string; price: number }> {
  return addonIds.map(id => ({
    id,
    name: getAddonName(id),
    price: getAddonPrice(id),
  }));
}

/**
 * Преобразует массив ID исключаемых ингредиентов в массив объектов с названиями
 * @param excludeIds - Массив ID исключаемых ингредиентов (string[] или number[])
 * @returns Массив объектов { id, name }
 */
export function mapExcludeIdsToNames(excludeIds: (string | number)[]): Array<{ id: string | number; name: string }> {
  return excludeIds.map(id => ({
    id,
    name: getExcludeName(id),
  }));
}










